import { render } from "./SystemList.vue?vue&type=template&id=1e10d51b&scoped=true"
import script from "./SystemList.vue?vue&type=script&lang=js"
export * from "./SystemList.vue?vue&type=script&lang=js"

import "./SystemList.vue?vue&type=style&index=0&id=1e10d51b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e10d51b"]])

export default __exports__